import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import CourseForm from './CourseForm';
import { addCourse } from '../../services/courseService';

import { formatCategoriesArray } from '../../utilities/courseFormat';
// import './courseForm.css';

function CourseAdd(props) {
  const [initialValues, setInitialValues] = useState({
    code: '',
    description: '',
    title: '',
    isActive: true,
    isOffline: false,
    studentCount: 0,
    instructorCount: 0,
    units: [],
    benefits: [],
    price: '',
    currency: 'USD',
    duration: '',
    classTime: '',
    videoTime: '',
    mode: '',
    type: '',
    by: '',
    university: '',
    meetCreatorRecordingLink: '',
    firstSuggestedCourse: '',
    secondSuggestedCourse: ''
  });

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const onSubmit = async (values) => {
    console.log('Initial value', initialValues);

    let payload = {
      ...values
    };

    setStatus({ type: 'LOADING', message: 'Request in Progress!' });
    if (payload.categories)
      payload.categories = formatCategoriesArray(payload.categories);
    await addCourse(payload)
      .then((response) => {
        console.log('Successfully Added! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data added successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data to backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };
  return (
    <Modal
      title={`Add Course`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CourseForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={props.isOpen}
          setStatus={setStatus}
          feedbackTemplates={props.feedbackTemplates}
        />
      )}
    </Modal>
  );
}

export default CourseAdd;
